import React from 'react';
import './UserProfileSkeleton.css';

function UserProfileSkeleton() {
  return (
    <div className="userprofile-skeleton-container">
      <div className="userprofile-skeleton-header">
        <div className="userprofile-skeleton-avatar" />
        <div className="userprofile-skeleton-username" />
        <div className="userprofile-skeleton-role-location" />
        <div className="userprofile-skeleton-bio" />
        <div className="userprofile-skeleton-follow-row" />
      </div>

      <div className="userprofile-skeleton-actions">
        <div className="userprofile-skeleton-button" />
        <div className="userprofile-skeleton-button" />
      </div>

      <div className="userprofile-skeleton-tabs">
        <div className="userprofile-skeleton-tab" />
        <div className="userprofile-skeleton-tab" />
        <div className="userprofile-skeleton-tab" />
        <div className="userprofile-skeleton-tab" />
      </div>

      <div className="userprofile-skeleton-posts">
        {[1, 2, 3].map((i) => (
          <div key={i} className="userprofile-skeleton-post">
            <div className="post-header-skeleton" />
            <div className="post-text-skeleton" />
            <div className="post-media-skeleton" />
            <div className="post-actions-skeleton" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default UserProfileSkeleton;
